import { z } from 'zod';

/** Voce della cassaforte senza segreti (per elenchi e ricerca). */
export interface VaultEntry {
  id: string;
  pageId: string | null;
  service: string;
  label: string;
  url: string;
  hasUsername: boolean;
  hasPassword: boolean;
  hasNotes: boolean;
  createdAt: string;
  updatedAt: string;
  lastRevealedAt: string | null;
}

/** Parte cifrata: si legge solo dopo la ri-conferma. */
export interface VaultSecret {
  username: string;
  password: string;
  notes: string;
  recoveryCodes: string;
}

const secretFields = {
  username: z.string().max(500).optional(),
  password: z.string().max(1000).optional(),
  notes: z.string().max(20000).optional(),
  recoveryCodes: z.string().max(5000).optional(),
};

export const vaultCreateSchema = z.object({
  pageId: z.string().nullable().optional(),
  service: z.string().trim().min(1, 'Scrivi il nome del servizio').max(120),
  label: z.string().trim().max(120).optional(),
  url: z.string().trim().max(500).optional(),
  ...secretFields,
});
export type VaultCreateInput = z.infer<typeof vaultCreateSchema>;

export const vaultUpdateSchema = vaultCreateSchema
  .partial()
  .refine((v) => Object.keys(v).length > 0, { message: 'Niente da salvare' });
export type VaultUpdateInput = z.infer<typeof vaultUpdateSchema>;

export const vaultListQuerySchema = z.object({
  pageId: z.string().optional(),
  q: z.string().max(100).optional(),
});

/** Inserimento di più accessi in una volta (dal riquadro "Incolla accessi").
 * Ogni voce può andare in una scheda diversa (pageId sulla voce); altrimenti vale quello generale. */
export const vaultBulkSchema = z.object({
  pageId: z.string().nullable().optional(),
  entries: z
    .array(
      z.object({
        pageId: z.string().nullable().optional(),
        service: z.string().trim().min(1).max(120),
        label: z.string().trim().max(120).optional(),
        url: z.string().trim().max(500).optional(),
        ...secretFields,
      }),
    )
    .min(1, 'Nessun accesso da salvare')
    .max(100, 'Troppi accessi insieme: dividili'),
});
export type VaultBulkInput = z.infer<typeof vaultBulkSchema>;
